import { TutorialStep } from "..";

export const InspTrainOptionSteps: TutorialStep[] = [
  {
    target: "#select-model",
    content:
      "검사 프로젝트는 학습을 위해 NG 이미지가 일정 수 이상 필요합니다.\n튜토리얼에서는 선택한 이미지 중 일부를 자동으로 NG로 등록했습니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#select-model",
    content: "학습/검증에 쓰일 모델을 선택할 수 있습니다.\n여기서는 기본값 그대로 진행합니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#finish-btn",
    content: "버튼을 클릭하여 프로젝트 생성을 완료합니다.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
];
